<div class="row pb-2 pb-sm-4">
  <!-- Sidebar -->
  <aside *ngIf="showFilters" class="col-lg-3">
    <div class="offcanvas-lg offcanvas-start d-none d-lg-block">
      <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
    </div>
  </aside>

  <div [ngClass]="(showFilters ? 'col-lg-9' : 'col-12')">
    <!-- Active filters + Sorting-->
    <div class="d-sm-flex align-items-start justify-content-between mb-4">
      <div class="d-flex align-items-center flex-shrink-0 mb-2 order-sm-1"><span
          class="text-muted text-nowrap fs-sm">Ordoneaza dupa:</span>
        <select [(ngModel)]="sort" (ngModelChange)="onSortChange()" class="form-select form-select-flush py-0">
          <option value="implicit">Implicit</option>
          <option value="az">A-Z</option>
          <option value="za">Z-A</option>
        </select>
      </div>
      <div class="me-3 order-sm-0">
        <div class="nav d-md-none">
          <a (click)="activeFiltersCollapsed = !activeFiltersCollapsed" [class.collapsed]="activeFiltersCollapsed"
            [attr.aria-expanded]="!activeFiltersCollapsed" class="nav-link dropdown-toggle fs-sm p-0 mb-2">Filtre
            active</a>
        </div>
        <div [(ngbCollapse)]="activeFiltersCollapsed" class="collapse d-md-block">
          <div class="pt-2 pt-md-0">
            <a *ngIf="keywordFilter" (click)="onRemoveFilterClick({keyword: ''})"
              class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
              role="button">
              <span class="d-inline-flex align-items-center text-nowrap px-1">{{keywordFilter}}<i
                  class="ai-circle-x fs-base ms-1"></i></span></a>
            <a *ngFor="let category of categoriesFilter" (click)="onRemoveCategoryFilterClick(category.id)"
              class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
              role="button"><span class="d-inline-flex align-items-center text-nowrap px-1">{{category.name}}<i
                  class="ai-circle-x fs-base ms-1"></i></span></a>
            <a *ngFor="let location of locationsFilter" (click)="onRemoveLocationFilterClick(location.id)"
              class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
              role="button"><span class="d-inline-flex align-items-center text-nowrap px-1">{{location.name}}<i
                  class="ai-circle-x fs-base ms-1"></i></span></a>
            <button *ngIf="hasFilters" (click)="onRemoveAllFiltersClick()"
              class="btn btn-sm btn-secondary rounded-pill fw-medium py-1 px-2" type="button"><span class="px-1">Sterge
                toate filtrele</span></button>
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="vouchers" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150"
      (scrolled)="onScrolled()" class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-4">
      <div *ngFor="let x of filteredVouchers | slice:0:page * itemsPerPage" class="col">
        <div class="card border-2 bg-secondary">
          <div class="card-header text-center border-0 rounded-0 py-2 w-100 text-truncate">{{x.partnerName}}</div>
          <a [routerLink]="['/carduri-cadou', x.slug]">
            <img class="card-img border border-2" [src]="x.image" [alt]="x.name">
          </a>
        </div>
      </div>
    </div>

    <!-- No filter results template -->
    <div *ngIf="vouchers?.length > 0 && filteredVouchers?.length === 0" class="card border-0 bg-secondary text-center">
      <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
      <div class="card-body">
        <h4 class="card-title">Nicio inregistrare</h4>
        <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
      </div>
    </div>

    <!-- Loading template -->
    <div *ngIf="!vouchers" class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-4">
      <div *ngFor="let item of [].constructor(itemsPerPage); index as index" class="col">
        <div class="card border-2 bg-secondary" aria-hidden="true">
          <div class="card-header border-0 rounded-0 py-2 placeholder-glow">
            <span class="placeholder col-10"></span>
          </div>
          <div class="position-relative placeholder-glow">
            <div class="card-img border border-2 placeholder ratio ratio-16x9"></div>
            <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #filtersTemplate let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">Filtre</h5>
    <button (click)="offcanvas?.dismiss()" class="btn-close" type="button"></button>
  </div>
  <div class="offcanvas-body pt-2 pt-lg-0 pe-lg-4">
    <form [formGroup]="form" novalidate autocomplete="off">
      <!-- Search -->
      <h3 class="h5">Cautare</h3>
      <div class="pb-2 mb-4">
        <div class="me-2 mb-2">
          <div class="position-relative mb-lg-2"><i
              class="ai-search fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
            <input formControlName="keyword" class="form-control form-control-sm ps-5" type="search"
              placeholder="Cauta dupa titlu...">
          </div>
        </div>
      </div>
      <!-- Categories -->
      <h3 class="h5">Categorii</h3>
      <div formArrayName="categories" class="pb-2 mb-4">
        <div *ngFor="let category of categories; index as i" class="form-check">
          <input [formControlName]="i" class="form-check-input" type="checkbox" id="category-{{category.id}}">
          <label class="form-check-label d-flex align-items-center" for="category-{{category.id}}"><span
              class="text-nav fw-medium">{{category.name}}</span></label>
        </div>
      </div>
      <!-- Locations -->
      <h3 class="h5">Locatii</h3>
      <div formArrayName="locations" class="pb-2">
        <div *ngFor="let location of locations; index as i" class="form-check">
          <input [formControlName]="i" class="form-check-input" type="checkbox" id="location-{{location.id}}">
          <label class="form-check-label d-flex align-items-center" for="location-{{location.id}}"><span
              class="text-nav fw-medium">{{location.name}}</span></label>
        </div>
      </div>
    </form>
  </div>
  <!-- Footer -->
  <div class="offcanvas-header d-flex border-top d-lg-none">
    <button (click)="offcanvas?.dismiss()" class="btn btn-dark w-100 me-2" type="button">
      Aplica
    </button>
  </div>
</ng-template>
